exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdt-offers-upperwrap[_v-15f73ffb]{max-width:1000px;width:100%;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-15f73ffb&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/layout/hotel-offers.vue
// module id = 340
// module chunks = 0